import React from 'react'
import PropTypes from 'prop-types'

import Moment from 'moment'

import Logo from 'assets/images/logo-gc.png'

const Item = (props) => {
  const row = props.row
  const logo = row.logo
    ? row.logo
    : Logo

  return (
    <tr>
      <td> {props.indexKey + 1} </td>
      <td> {Moment(`${row.createdAt}`).format('MMMM, DD YYYY')} </td>
      <td> <span className="capitalize">{row.name} </span></td>
      <td> <span className="capitalize">{row.team} </span></td>
      <td> <span className="capitalize">{row.country.name} </span></td>
      <td> <span className="capitalize">{row.city.name} </span></td>
      <td>
        <span className="capitalize">
          <img alt={props.row.name} src={logo} className="img-responsive" style={{ width: '100px' }} />
        </span>
      </td>
      <td>
        <a href="" className="btn btn-icon-only dark">
          <i className="fa fa-pencil" />
        </a>
      </td>
    </tr>
  )
}

Item.defaultProps = {
  row: {
    logo: '',
    createdAt: '',
    name: '',
    team: '',
    country: {
      name: '',
    },
    city: {
      name: '',
    },
  },
  indexKey: 0,
}

Item.propTypes = {
  row: PropTypes.shape({
    logo: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    team: PropTypes.string.isRequired,
    country: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    city: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
